var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.userLoggedIn)?_c('global-header'):_vm._e(),_c('v-main',[_c('router-view'),_c('global-eventSelectorMobile')],1),(_vm.userLoggedIn)?_c('global-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }